import type { LockCalculatorFormValues } from "./form";
import { hasRealLoadValue } from "./structuralVisibility";

/**
 * Form paths still lacking for a fully specified configuration — what the "generate manual solution"
 * action needs, while "generate from data" is meant for a partial one. A lateral load needs its
 * resistance mechanism, chosen in the structure step.
 */
export const missingConnectorsInputs = (values: LockCalculatorFormValues): string[] => {
  const missing: string[] = [];
  if (hasRealLoadValue(values.loads?.lateral) && values.lateralResistanceConfig == null) missing.push("lateralResistanceConfig");
  if (!values.connectorPairs?.[0]?.lockItemId) missing.push("connectorPairs.0.lockItemId");
  if (values.connectorPairCount === 2 && !values.connectorPairs?.[1]?.lockItemId) missing.push("connectorPairs.1.lockItemId");
  if (!values.fasteners?.headerItemId) missing.push("fasteners.headerItemId");
  if (!values.fasteners?.joistItemId) missing.push("fasteners.joistItemId");
  if (values.lateralResistanceConfig === 3 && !values.fasteners?.inclinedItemId) missing.push("fasteners.inclinedItemId");
  if (values.lateralResistanceConfig === 4 && !values.lockstopItemId) missing.push("lockstopItemId");
  return missing;
};

/**
 * Reports whether every field the Connectors step requires is filled in —
 * used to decide which of the two step-4 actions is enabled: "generate
 * manual solution" needs a fully specified configuration, while "generate
 * from data" is meant for a still-partial one.
 */
export const isConnectorsStepComplete = (values: LockCalculatorFormValues): boolean =>
  missingConnectorsInputs(values).length === 0;
